import { ColWrap, MainCol, SecondaryCol } from "common/layouts/SideNavLayout/TwoCol";
import { experienceSelectors } from "data/resources/experiences";
import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getExperienceId } from "../ExperiencesApp/ExperiencesApp";
import { Routes } from "../RoutesPage/Routes";
import { Details } from "./Details";
import { GuideBlock } from "./GuideBlock";
import { Messages } from "./Messages";
import { Publish } from "./Publish";
import { Share } from "./Share";
import { Stats } from "./Stats";

export class _Overview extends React.PureComponent {
  render() {
    const { experience, lastPackage, hasUpdates, allowMessaging } = this.props;

    if (!experience) return <div />;

    return (
      <ColWrap>
        {experience && <Helmet title={experience.name} />}
        <MainCol>
          <Details experience={experience} />
          <Routes experience={experience} preview editable />
          <GuideBlock experience={experience} />
        </MainCol>
        <SecondaryCol>
          <Publish lastPackage={lastPackage} hasUpdates={hasUpdates} experience={experience} />
          <Share
            isPublished={lastPackage && lastPackage.packageFileSize && experience.active}
            experience={experience}
          />
          <Stats experience={experience} />
          {allowMessaging && <Messages experience={experience} />}
        </SecondaryCol>
      </ColWrap>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = getExperienceId(ownProps);
  return {
    experience: experienceSelectors.find(state, id),
    lastPackage: experienceSelectors.lastPackage(state, id),
    hasUpdates: experienceSelectors.hasUpdates(state, id),
    allowMessaging: experienceSelectors.allowMessaging(state, id),
  };
};

export const Overview = withRouter(connect(mapStateToProps, null)(_Overview));
